var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgUsers = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.152 10.531c0.922-0.029 1.747-0.42 2.344-1.034l0.001-0.001c-0.659-1.132-1.057-2.488-1.080-3.934l-0-0.007c0-0.002 0-0.003 0-0.005 0-1.141 0.279-2.217 0.773-3.163l-0.018 0.038c-0.58-0.362-1.285-0.576-2.040-0.577h-0c-2.189 0.010-3.96 1.787-3.96 3.978 0 0.007 0 0.014 0 0.020v-0.001c0.001 2.207 1.793 4.686 3.98 4.686z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.814 12.314c-0.36-0.082-0.775-0.129-1.2-0.13h-2.942c-0.001 0-0.002 0-0.004 0-3.13 0-5.667 2.536-5.669 5.665v0l0.013 0.67c0.001 0.874 0.71 1.583 1.584 1.583 0 0 0.001 0 0.001 0h2.903c0.152-3.473 2.266-6.418 5.256-7.765l0.056-0.023z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.166 11.368c2.711 0 4.884-3.074 4.884-5.812 0-2.711-2.198-4.909-4.909-4.909s-4.909 2.198-4.909 4.909v0c0 2.737 2.224 5.812 4.934 5.812z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.983 20.468c-0.003-3.88-3.148-7.024-7.028-7.024-0.002 0-0.003 0-0.005 0h-3.651c-0.001 0-0.003 0-0.005 0-3.88 0-7.026 3.144-7.028 7.023v0l0.017 0.83c0.003 1.082 0.882 1.958 1.964 1.958 0 0 0.001 0 0.001 0h13.787c0 0 0.001 0 0.001 0 1.084 0 1.963-0.878 1.964-1.962v-0z"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUsers, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/users.d3cda63e.svg";
export { ForwardRef as ReactComponent };